import { isMobile } from '@/device/deviceConfig'
import { getString } from '@/header/i18n/bundle.generated'
import { openExternal } from '@/components/openExternal'
import { ctx } from '@/util/context'

const { errorHandler } = ctx('openGetApp')

/** A phone goes straight to the app store link; a computer shows a QR code to scan with one. */
export function openGetApp(deeplinkUrl: string): void {
    if (isMobile()) {
        openExternal(deeplinkUrl)
        return
    }
    import('@/components/PhoneHandoffModal')
        .then(({ openPhoneHandoff }) =>
            openPhoneHandoff({
                title: getString('dmusic_get_app_modal_title'),
                message: getString('dmusic_get_app_modal_subtitle'),
                url: deeplinkUrl,
                showUrl: false,
            })
        )
        .catch(errorHandler)
}
